import { useDispatch, useSelector } from 'react-redux';

import { RootState } from '../reducers';
import * as actions from '../actions/dataPlayers';
import { getDataPlayersByTeamId, replaceDataPlayers } from '../actions';
import { DataPlayersState } from '../types';
import { bindActionCreators } from 'redux';
import { useRouter } from '../../helpers/customHooks';

export const useDataPlayersState = (playerId?: string) => {
  const dataPlayers = useSelector((state: RootState) => state.dataPlayers) as DataPlayersState;
  if (playerId && dataPlayers[playerId]) {
    return { 
      dataPlayers, 
      dataPlayer: dataPlayers[playerId],
      playerGames: dataPlayers[playerId].events?.games,
      playerPractices: dataPlayers[playerId].events?.practices
    };
  }
  return { dataPlayers };
};

interface Match { match: { playerId: string } };

export const useDataPlayersDispatch = () => {
  const { match } = useRouter<Match>();
  const dispatch = useDispatch();
  return {
    ...bindActionCreators({ ...actions  }, dispatch),
    replaceDataPlayers: (players: DataPlayersState) => () => dispatch(replaceDataPlayers(players)),
    getDataPlayersByTeamId: (teamId: string, type?: string) => () => dispatch(getDataPlayersByTeamId(teamId, type)),
    getPlayerMetrics: () => {
      dispatch(actions.getDataPlayersPlayerPractices(match.params.playerId));
    }
  };
};